import { getLeaveAction } from '@components/Dashboard/utils'
import type { ID } from '@octopus-do/octopus-project-core'
import { DashboardActions } from '@store/reducers/dashboard/actions'
import { useDispatch } from 'react-redux'

import { createSwitch } from '@/utils'
import {
  getAssignManagerAction,
  getRemoveAction,
  getSuspendAction,
} from './utils'

export const useMembersList = (workspaceId: ID) => {
  const dispatch = useDispatch()
  const switcher = createSwitch()
    .case(['member'], (id) =>
      dispatch(
        DashboardActions.members.changeRole({
          id,
          workspaceId,
          role: 'MEMBER',
        })
      )
    )
    .case(['manager'], (id) =>
      dispatch(getAssignManagerAction(workspaceId, id))
    )
    .case(['suspend'], (id) => dispatch(getSuspendAction(workspaceId, id)))
    .case(['unsuspend'], (id) => {
      dispatch(
        DashboardActions.members.unsuspend({
          id,
          workspaceId,
        })
      )
    })
    .case(['delete'], (id) => dispatch(getRemoveAction(workspaceId, id)))
    .case(['leave_team'], () => dispatch(getLeaveAction(workspaceId)))
    .case(['cancel_invitation'], (id) => {
      dispatch(
        DashboardActions.members.cancelInvitation({
          id,
          workspaceId,
        })
      )
    })

  const onClick = (...keys: string[]) => {
    switcher.run(keys)
  }

  return { onClick }
}
